module.exports = __webpack_public_path__ + "6f3bdc8fc5f66c0e8f7072363ba8511b.png";